import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccordion, LazyAccordionWithDynamicImage, LazyAlert, LazyAnchorButtons, LazyAnchorSections, LazyBackground, LazyBestBuyBanner, LazyBigCampaignBlockItem, LazyBlankSpace, LazyBookingVerification, LazyButtonLink, LazyCampaignBlock, LazyCampaignBlockItem, LazyCard, LazyCardsSlider, LazyClubMap, LazyComponentTest, LazyContainerWrapper, LazyContentTypes, LazyDestinationCard, LazyDivider, LazyFareTypes, LazyFeatureBanner, LazyFilterableSlider, LazyFilterableSliderCard, LazyFlightPlusHotel, LazyFormSelector, LazyHalfContentHalfImage, LazyHeroBanner, LazyHeroBannerSlider, LazyHeroImageParallax, LazyInfoBlock, LazyInfoBlockCta, LazyInfoCard, LazyInfoCardsList, LazyIntroTextBlock, LazyLinkRef, LazyLinksGrid, LazyList, LazyLogoLinks, LazyLogosGrid, LazyMedia, LazyMobileAppBanner, LazyNewsletterSubscriptionForm, LazyNewsletterUnsubscribeForm, LazyOffers, LazyOffersBlock, LazyOriginDestination, LazyPageSwitcher, LazyPageTitle, LazyPromotionalBanner, LazyScrollingBanner, LazyScrollingBannerItems, LazySearchTable, LazySiloSections, LazySimpleTable, LazySkyshopAnchors, LazySlider, LazySliderCardWide, LazySmallCampaignBlockItem, LazySmallCampaignBlockItemWithImageOnTop, LazySplitLayoutWrapper, LazyStoryblokLabel, LazySubscribeBlockPopup, LazySubscribeBlok, LazySubtitle, LazyTilesSlider, LazyTrendingRoutesBlock, LazyUspCard, LazyUspSection, LazyVideoBanner, LazyVideoHeroBanner, LazyWysiwyg, LazyWysiwygMinimal, LazyTestData, LazyClpBanner, LazyClpEndedBanner, LazyClpInfluencerBlock, LazyDestinationAirportInfo, LazyDestinationBlogTeaser, LazyDestinationHero, LazySingleDestinationTextBlock, LazyFareTable, LazyServiceBody, LazyServiceSummary, LazyFilterableCards, LazyFilterableCardsFilterButtons, LazyWideHero, LazyMealCardModal, LazyMealsMenuCard, LazySiloItemLarge, LazySiloItemMedium, LazySiloItemSmall, LazyHeaderI18n, LazyHeaderLink, LazyHeaderOffers, LazyHeaderProfile, LazyHeaderSearch, LazyClp, LazyIndexPage, LazyPage, LazyPageTypeTypes, LazySilo, LazySingleDestination, LazyClpUpload, LazyNote, LazySidebarLinks, LazyTestimonialSlider, LazyBookingWidget, LazyBookingWidgetSimple, LazyCargoTrackingWidget, LazyCookiebotWidget, LazySherpaMapWidget, LazySherpaWidget, LazySixtWidget, LazyNuxtIcon } from '#components'
const lazyGlobalComponents = [
  ["Accordion", LazyAccordion],
["AccordionWithDynamicImage", LazyAccordionWithDynamicImage],
["Alert", LazyAlert],
["AnchorButtons", LazyAnchorButtons],
["AnchorSections", LazyAnchorSections],
["Background", LazyBackground],
["BestBuyBanner", LazyBestBuyBanner],
["BigCampaignBlockItem", LazyBigCampaignBlockItem],
["BlankSpace", LazyBlankSpace],
["BookingVerification", LazyBookingVerification],
["ButtonLink", LazyButtonLink],
["CampaignBlock", LazyCampaignBlock],
["CampaignBlockItem", LazyCampaignBlockItem],
["Card", LazyCard],
["CardsSlider", LazyCardsSlider],
["ClubMap", LazyClubMap],
["ComponentTest", LazyComponentTest],
["ContainerWrapper", LazyContainerWrapper],
["ContentTypes", LazyContentTypes],
["DestinationCard", LazyDestinationCard],
["Divider", LazyDivider],
["FareTypes", LazyFareTypes],
["FeatureBanner", LazyFeatureBanner],
["FilterableSlider", LazyFilterableSlider],
["FilterableSliderCard", LazyFilterableSliderCard],
["FlightPlusHotel", LazyFlightPlusHotel],
["FormSelector", LazyFormSelector],
["HalfContentHalfImage", LazyHalfContentHalfImage],
["HeroBanner", LazyHeroBanner],
["HeroBannerSlider", LazyHeroBannerSlider],
["HeroImageParallax", LazyHeroImageParallax],
["InfoBlock", LazyInfoBlock],
["InfoBlockCta", LazyInfoBlockCta],
["InfoCard", LazyInfoCard],
["InfoCardsList", LazyInfoCardsList],
["IntroTextBlock", LazyIntroTextBlock],
["LinkRef", LazyLinkRef],
["LinksGrid", LazyLinksGrid],
["List", LazyList],
["LogoLinks", LazyLogoLinks],
["LogosGrid", LazyLogosGrid],
["Media", LazyMedia],
["MobileAppBanner", LazyMobileAppBanner],
["NewsletterSubscriptionForm", LazyNewsletterSubscriptionForm],
["NewsletterUnsubscribeForm", LazyNewsletterUnsubscribeForm],
["Offers", LazyOffers],
["OffersBlock", LazyOffersBlock],
["OriginDestination", LazyOriginDestination],
["PageSwitcher", LazyPageSwitcher],
["PageTitle", LazyPageTitle],
["PromotionalBanner", LazyPromotionalBanner],
["ScrollingBanner", LazyScrollingBanner],
["ScrollingBannerItems", LazyScrollingBannerItems],
["SearchTable", LazySearchTable],
["SiloSections", LazySiloSections],
["SimpleTable", LazySimpleTable],
["SkyshopAnchors", LazySkyshopAnchors],
["Slider", LazySlider],
["SliderCardWide", LazySliderCardWide],
["SmallCampaignBlockItem", LazySmallCampaignBlockItem],
["SmallCampaignBlockItemWithImageOnTop", LazySmallCampaignBlockItemWithImageOnTop],
["SplitLayoutWrapper", LazySplitLayoutWrapper],
["StoryblokLabel", LazyStoryblokLabel],
["SubscribeBlockPopup", LazySubscribeBlockPopup],
["SubscribeBlok", LazySubscribeBlok],
["Subtitle", LazySubtitle],
["TilesSlider", LazyTilesSlider],
["TrendingRoutesBlock", LazyTrendingRoutesBlock],
["UspCard", LazyUspCard],
["UspSection", LazyUspSection],
["VideoBanner", LazyVideoBanner],
["VideoHeroBanner", LazyVideoHeroBanner],
["Wysiwyg", LazyWysiwyg],
["WysiwygMinimal", LazyWysiwygMinimal],
["TestData", LazyTestData],
["ClpBanner", LazyClpBanner],
["ClpEndedBanner", LazyClpEndedBanner],
["ClpInfluencerBlock", LazyClpInfluencerBlock],
["DestinationAirportInfo", LazyDestinationAirportInfo],
["DestinationBlogTeaser", LazyDestinationBlogTeaser],
["DestinationHero", LazyDestinationHero],
["SingleDestinationTextBlock", LazySingleDestinationTextBlock],
["FareTable", LazyFareTable],
["ServiceBody", LazyServiceBody],
["ServiceSummary", LazyServiceSummary],
["FilterableCards", LazyFilterableCards],
["FilterableCardsFilterButtons", LazyFilterableCardsFilterButtons],
["WideHero", LazyWideHero],
["MealCardModal", LazyMealCardModal],
["MealsMenuCard", LazyMealsMenuCard],
["SiloItemLarge", LazySiloItemLarge],
["SiloItemMedium", LazySiloItemMedium],
["SiloItemSmall", LazySiloItemSmall],
["HeaderI18n", LazyHeaderI18n],
["HeaderLink", LazyHeaderLink],
["HeaderOffers", LazyHeaderOffers],
["HeaderProfile", LazyHeaderProfile],
["HeaderSearch", LazyHeaderSearch],
["Clp", LazyClp],
["IndexPage", LazyIndexPage],
["Page", LazyPage],
["PageTypeTypes", LazyPageTypeTypes],
["Silo", LazySilo],
["SingleDestination", LazySingleDestination],
["ClpUpload", LazyClpUpload],
["Note", LazyNote],
["SidebarLinks", LazySidebarLinks],
["TestimonialSlider", LazyTestimonialSlider],
["BookingWidget", LazyBookingWidget],
["BookingWidgetSimple", LazyBookingWidgetSimple],
["CargoTrackingWidget", LazyCargoTrackingWidget],
["CookiebotWidget", LazyCookiebotWidget],
["SherpaMapWidget", LazySherpaMapWidget],
["SherpaWidget", LazySherpaWidget],
["SixtWidget", LazySixtWidget],
["NuxtIcon", LazyNuxtIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
